export const LANDING = '/landing';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const HOME = '/app';
export const ACCOUNT = '/app/account';
export const ADMIN = '/app/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const TODAY = '/';